module.exports = __webpack_public_path__ + "img/yaoqing.abd1d059.png";